<template>
  <div style="margin-bottom: 100px;position: relative;padding-top: 50px;">
    <img src="../../assets/images/Background6.png" style="position: absolute;top: 0px;left: 0px;">
    <div style="position: relative;">
      <div style="font-size: 30px;text-align: center;">联系销售</div>
      <div style="margin-top: 30px;font-size: 16px;color: #1e66d1;font-weight: bold;text-align: center;">
        留下您的联系方式,我们将在24小时内尽快与您取得联系</div>
      <div style="font-size: 16px;margin: 0px auto;margin-top: 60px;width: 500px;">
        <div>公司名称</div>
        <div style="margin-top: 18px;">
          <input v-model="form.cname" placeholder="请输入您的公司全称" type="text" />
        </div>
        <div style="margin-top: 30px;">如何称呼您</div>
        <div style="margin-top: 18px;">
          <input v-model="form.uname" placeholder="请输入" type="text" />
        </div>
        <div style="margin-top: 30px;">联系电话</div>
        <div style="margin-top: 30px;">
          <input v-model="form.phone" placeholder="请输入" type="text" />
        </div>
        <div style="margin-top: 30px;">邮箱<span style="color: #1e66d1;">（选填）</span></div>
        <div style="margin-top: 18px;">
          <input v-model="form.email" placeholder="请输入" type="text" />
        </div>
        <div style="margin-top: 30px;">留言<span style="color: #1e66d1;">（选填）</span></div>
        <div style="margin-top: 18px;">
          <textarea rows="5" type="text" style="height: 100px;" cols="50" v-model="form.remarks"
            placeholder="请输入您想了解的产品或其他相关信息" />
        </div>
      </div>
      <div style="width: 200px;height: 40px;line-height: 42px;color: #fff;background:#1e66d1 ;text-align: center;
        margin: 0px auto;font-size: 16px;border-radius: 5px;margin-top: 38px;cursor: pointer;" @click="submit">提交合作信息
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        cname: '',
        uname: '',
        phone: '',
        email: '',
        remarks: '',
      }
    }
  },
  mounted() {
  },
  methods: {
    submit() {
      if (!this.form.cname) { 
        alert('请填入公司名称') 
        return 
      }
      if (!this.form.uname) { 
        alert('请填入您的称呼') 
        return 
      }
      if (!this.form.phone && !this.form.email) { 
        alert('请填入联系方式') 
        return 
      }
      this.$http('/CrmCase/CreateOrUpdateContact', this.form).then(res => {
        alert('成功')
      })
    }
  }
}
</script>
<style scoped>
input {
  width: 100%;
  height: 42px;
  border-radius: 5px;
  padding-left: 16px;
  font-size: 15px;
  border: 1px solid #f4f4f4;
  box-shadow: rgba(217, 217, 217, 0.5) 0px 6px 10px 0px;
  /* box-shadow: rgba(176, 176, 176, 0.5) 0px 0px 0px 0px; */
}

textarea {
  width: 100%;
  height: 42px;
  border-radius: 5px;
  padding-left: 16px;
  font-size: 15px;
  border: 1px solid #ededed;
  box-shadow: rgba(208, 208, 208, 0.5) 0px 6px 10px 0px;
  padding-top: 5px;
}
</style>